import { render, staticRenderFns } from "./ArticleSegmentEdit.vue?vue&type=template&id=576a5d37"
import script from "./ArticleSegmentEdit.vue?vue&type=script&lang=js"
export * from "./ArticleSegmentEdit.vue?vue&type=script&lang=js"
import style0 from "./ArticleSegmentEdit.vue?vue&type=style&index=0&id=576a5d37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports